import { AssetCustomField, AssetInstance } from '../../constants/Types';
import { AssetFilterSelection } from './components/AssetFilterModal/components/AssetFilterItem';

export const isPlacedOnMap = (asset: AssetInstance) => {
  let hasXY: boolean = false;
  const coordFields: string[] = ['geox', 'geoy'];
  asset.customFields.forEach((field: AssetCustomField) => {
    if (!hasXY && coordFields.includes(field.name.trim().toLowerCase())) {
      hasXY = true;
    }
  });
  return hasXY;
};

export const assetLocationName = (asset: AssetInstance) => {
  let locationName: string = asset.locationFloor;
  if (asset.locationArea) locationName += `, ${asset.locationArea}`;
  if (asset.locationSpace) locationName += `, ${asset.locationSpace}`;
  return locationName;
};

export const buildPpmLink = (ppmUrl: string, asset: AssetInstance): string => {
  const legacyLink = `${ppmUrl}${encodeURIComponent(asset.id)}`
    + `&assetName=${encodeURIComponent(asset.name)}`
    + `&locationName=${encodeURIComponent(assetLocationName(asset))}`;

  try {
    const link = new URL(ppmUrl);
    const prefillParameters = Array.from(link.searchParams.entries())
      .filter(([parameterName]) => parameterName !== 'id');

    if (link.hostname === 'forms.cloud.microsoft' && prefillParameters.length > 0) {
      const prefillValues = [
        ['assetid', String(asset.id)],
        ['assetname', asset.name],
        ['assetlocation', assetLocationName(asset)],
      ];

      prefillValues.forEach(([placeholder, value], index) => {
        const parameterName = prefillParameters
          .find(([, parameterValue]) => parameterValue.toLowerCase() === placeholder)?.[0]
          ?? prefillParameters[index]?.[0];

        if (parameterName) link.searchParams.set(parameterName, value);
      });
      // console.log('buildPpmLink', link.toString());
      return link.toString().replace(/\+/g, '%20');
    }
  } catch {
    return legacyLink;
  }

  return legacyLink;
};

export const checkIfFiltersApplied = (filters: AssetFilterSelection[]): boolean => filters
  .filter((filter: AssetFilterSelection) => !!filter.value).length > 0;
